<template>
  <div :class="$style.container">
    <h4
      :class="$style.title"
      v-if="title"
      v-text="title"
      v-font-style="fontDetailHeading"
      v-color="'white'"
      v-background-color="colorBackgroundHeading"
    />
    <h5
      v-font-style="fontDetail"
      v-color="colorFont"
      v-for="item in list"
      :key="item.fields.slug"
      @click="handleSelect(item)"
      ontouchstart=""
      >{{ item.fields.displayName }}</h5
    >
  </div>
</template>
<script>
import { TweenLite, Power4 } from 'gsap'
import('gsap/src/uncompressed/plugins/ScrollToPlugin')

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
    colorFont: {
      type: String,
      default: '',
    },
    colorBackground: {
      type: String,
      default: '',
    },
    colorBackgroundHeading: {
      type: String,
      default: '',
    },
    fontDetail: {
      type: Object,
      default: () => {},
    },
    fontDetailHeading: {
      type: Object,
      default: () => {},
    },
  },
  beforeMount() {
    TweenLite.set(window, { scrollTo: window.scrollY - 1 })
  },
  mounted() {
    TweenLite.to(window, 1, {
      scrollTo: document.body.offsetHeight - window.innerHeight,
      ease: Power4.easeInOut,
    })
  },
  methods: {
    handleSelect(item) {
      this.$emit('select', item)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.container {
  background: #fff;
  font-size: 18px;
  margin-bottom: 60px;
  text-align: left;
  width: 100%;
  max-width: 298px;
  box-shadow: 0.25px 0.5px 0px 1px #d8d8d8;

  h4,
  h5 {
    margin: 0;
    padding: 14px 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-weight: normal;
    white-space: pre;
  }

  h5 {
    border-top: 1px solid rgba(135, 135, 135, 0.5);
    font-size: 16px;
  }

  h5:first-child,
  h5:nth-child(2) {
    border-top: none;
  }

  h4 {
    font-size: 15px;
  }
}
</style>
